import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { TituloAbaService } from "../titulo-aba/titulo-aba.service";
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  SwiperOptions,
} from "swiper";

import { HomeService } from "./providers/home.service";
import { CardModel } from "src/app/shared/models/card.model";
import { configCarrossel } from "src/app/shared/utils/carouselConfig";

SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [HomeService],
})
export class HomeComponent implements OnInit {
  tituloAppCaixa = "App DA AZULZINHA";
  rota = "home";

  bandeiras: string[] = [];
  cards: CardModel[] = [];
  configCarrossel: SwiperOptions["breakpoints"] = configCarrossel;

  constructor(
    private tituloAbaService: TituloAbaService,
    private homeService: HomeService
  ) {
    this.tituloAbaService.setTitle("Home");
    this.tituloAbaService.setMeta(
      "description",
      "A azulzinha da CAIXA tem a solução ideal para você vender mais no presencial, na internet e gerenciar seu negócio com agilidade e segurança. Descubra aqui!"
    );

    this.bandeiras = this.homeService.getBandeiras();
    this.cards = this.homeService.getCards();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
